import React, { FC } from 'react'

const BriefcaseFull: FC<DefaultPropsIcon> = (props) => {
  const { size = 60, onClick, className, color = '#818C99' } = props

  return (
    <span className={['anticon', 'anticon-setting', className || ''].join(' ')} onClick={onClick}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <path
          d="M40 20L40 15C40 12.22 37.77 10 35 10L25 10C22.22 10 20 12.22 20 15L20 20L15 20C12.23 20 10 22.23 10 25L10 42.5C10 45.26 12.23 47.5 15 47.5L45 47.5C47.76 47.5 50 45.26 50 42.5L50 25C50 22.23 47.76 20 45 20L40 20ZM25 20L25 15L35 15L35 20L25 20Z"
          fill={color}
          fillOpacity="1.000000"
          fillRule="nonzero"
        />
      </svg>
    </span>
  )
}

export default BriefcaseFull
